export default __webpack_public_path__ + "static/media/Cattura6.f2c9f07e.jpg";